import React, { useEffect, useRef } from 'react';
import styled from 'libs/styled';

const Wrapper = styled('div')`
    width: 100%;
    padding: 0 var(--grid-padding, 10px);
`;

const CookietractorInformation: React.FC = () => {
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!containerRef.current) return;

        const script = document.createElement('script');
        script.id = 'CookieDeclaration';
        script.src = 'https://consent.cookietractor.com/1813c498-fa6b-4fb3-b498-1d9e48a7299d/cd.js';
        script.type = 'text/javascript';
        script.async = true;

        containerRef.current.appendChild(script);

        return () => {
            script.remove();
        };
    }, []);

    return (
        <Wrapper>
            <div ref={containerRef} />
        </Wrapper>
    );
};

export default CookietractorInformation;
